import { render, staticRenderFns } from "./PortfolioDetails.vue?vue&type=template&id=5dea7d73&scoped=true&"
import script from "./PortfolioDetails.vue?vue&type=script&lang=js&"
export * from "./PortfolioDetails.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioDetails.vue?vue&type=style&index=0&id=5dea7d73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dea7d73",
  null
  
)

export default component.exports